import { useI18n } from 'vue-i18n'
import { OrderStatus, OrderType } from './OrderModel'

export function parseEnumValue<T extends Record<string, string>>(
  enumObj: T,
  value: unknown
): T[keyof T] | null {
  return Object.values(enumObj).includes(value as T[keyof T]) ? (value as T[keyof T]) : null
}

export function formatDate(dateString: string | null | boolean): string {
  if (dateString === null) return ''
  if (dateString === true) return ''
  const date = new Date(dateString)

  if (isNaN(date.getTime())) {
    return ''
  }

  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')

  return `${yyyy}-${mm}-${dd}`
}

export function parseStatus(statusString: string): string {
  const { t } = useI18n()
  if (statusString === OrderStatus.collecting) return t('collecting')
  if (statusString === OrderStatus.pending) return t('pending')
  if (statusString === OrderStatus.hold) return t('hold')
  if (statusString === OrderStatus.cancel) return t('cancelled')
  if (statusString === OrderStatus.collected) return t('collected')
  if (statusString === OrderStatus.finished) return t('finished')
  return statusString
}

export function parseBadgeClass(statusString: string): string {
  if (
    statusString === OrderStatus.collecting ||
    statusString === OrderStatus.collected ||
    statusString === OrderStatus.finished
  ) {
    return 'green'
  }
  return 'red'
}

export function parseType(typeString: string): string | null {
  const { t } = useI18n()
  if (typeString === OrderType.outbound) return t('outbound')
  if (typeString === OrderType.inbound) return t('inbound')
  if (typeString === OrderType.inventory) return t('inventory')
  if (typeString === OrderType.order) return t('order')
  if (typeString === OrderType.backorder) return t('backorder')
  return null
}

export function parseNumber(value: unknown, fallback = 0): number {
  const n = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(n) ? n : fallback
}

export function parseString(value: unknown, fallback = ''): string {
  if (typeof value === 'string') return value
  if (typeof value === 'number' && Number.isFinite(value)) return String(value)
  if (typeof value === 'boolean') return value ? 'true' : 'false'
  return fallback
}

export function parseBoolean(value: unknown, fallback = false): boolean {
  if (typeof value === 'boolean') return value
  return fallback
}
